import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import DoctorCard from '../../../components/card/DoctorCard';
import DoctorFilterBottomSheet from '../../../components/filter/DoctorFilterBottomSheet';
import Service from '../../../components/modal/Service';
import HeaderWithBack from '../../../components/HeaderWithBack';
import axios from '../../../api/axios';
import BottomNav from '../../../components/BottomNav';

// tipe Doctor
type Doctor = {
  practitioner_role_id: string;
  name: string;
  specialization: string;
  years: number;
  rating: number;
  hospital: string;
  price: number;
  originalPrice?: number;
  photoUrl: string;
  is_online: boolean;
};

const ListDoctor: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const initialFilters = location.state?.filters || {};

  // ⬇️ Ini harus di dalam komponen
  const storedData = sessionStorage.getItem('userData');
  const userData = storedData ? JSON.parse(storedData) : null;
  const token = userData ? userData.token : null;
  const [showFilter, setShowFilter] = useState(false);
  const [showService, setShowService] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState<Doctor | null>(null);
  const [doctorData, setDoctorData] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filters, setFilters] = useState({
    gender: '',
    experience: '',
    schedule: '',
    ...initialFilters
  });
  const [homeData, setHomeData] = React.useState<any>(null);
  const isFilterActive = Object.values(filters).some(value => value !== '');

  const handleKonsultasiClick = (doctor: Doctor) => {
    setSelectedDoctor(doctor);
    setShowService(true);
  };

  useEffect(() => {
    const fetchPractitioner = async () => {
      if (!token) return;

      try {
        const params: Record<string, any> = { page: 1 };

        if (searchTerm?.trim()) params.search = searchTerm.trim();
        if (filters.gender) params.gender = filters.gender;
        if (filters.experience) params.year = filters.experience;
        if (filters.schedule !== '') params.is_online = filters.schedule;
        if (filters.speciality_id !== '') params.speciality_id = filters.speciality_id;


        const response = await axios.get(`practitoner-roles`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        });

        const practitioner = response.data.data;

        const practitionerDoctors = practitioner.map((item: any, index: number) => ({
          practitioner_role_id: item.id,
          name: `dr. ${item.name}`,
          specialization: item.speciality_name || 'Umum',
          years: parseInt(item.year_experience, 10),
          rating: Math.round((item.rating || 0) * 20),
          hospital: item.hospital_name?.replace(/\r?\n|\r/g, '').trim() || '',
          price: item.price_chat,
          photoUrl: item.avatar_url || `https://i.pravatar.cc/150?img=${index + 1}`,
          is_online: item.is_online || false,
        }));

        setDoctorData(practitionerDoctors);
      } catch (error) {
        console.error('Error fetching practitioner:', error);
      }
    };

    fetchPractitioner();
  }, [token, searchTerm, filters]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`home`, {
          params: {
            user_id: userData?.id,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          }
        });

        const data = response.data.data;
        console.log(data, "data");
        setHomeData(data);

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    
    fetchData(); // Selalu fetch saat Home dirender
  }, [token, userData?.id]);

  const handleServiceSubmit = (data: { waktu: 'sekarang' | 'jadwal'; layanan: string }) => {
    setShowService(false);
    // if (data.waktu === 'jadwal' && selectedDoctor) {
    //   navigate(`/schedule-consultation/${selectedDoctor?.practitioner_role_id}`, {
    //     state: { doctor: selectedDoctor },
    //   });
    // }

    // if (data.waktu === 'sekarang') {
    //   // handle konsultasi sekarang jika perlu
    //   navigate(`/disclaimer/${selectedDoctor?.practitioner_role_id}`);
    // }

    if (homeData?.teleconsult?.status === 'ongoing') {
      navigate(`/chat/${homeData?.teleconsult?.id}`);
    } else {
      if (data.waktu === 'sekarang') {
        navigate(`/disclaimer/${selectedDoctor?.practitioner_role_id}`);
      } else {
        navigate(`/schedule-consultation/${selectedDoctor?.name}`, {
        state: { doctor: selectedDoctor },
      });
    }
    }
  };
  

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <HeaderWithBack title="Tanya Dokter Kami" />

      {/* Header + Tombol Filter */}
      <div className="flex justify-between items-center px-4 mt-4 mb-2">
        <h3 className="text-md font-semibold">Daftar Dokter</h3>
        <button onClick={() => setShowFilter(true)}  className="relative flex items-center border border-morning-300 text-morning-300 text-sm px-3 py-1 rounded-full">
          <img src="/app-icons/filter.svg" alt="Filter" className="w-4 h-4 mr-1" />
          Filter
          {isFilterActive && (
            <img src="/app-icons/checklist.svg" alt="Checklist" className="ml-2 w-4 h-4" />
          )}
        </button>
      </div>

      {/* Input Search */}
      <div className="px-4 mb-4">
        <div className="relative">
          <span className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <img src="/app-icons/search.svg" alt="Search" className="w-4 h-4 text-gray-400" />
          </span>
          <input
            type="text"
            placeholder="Cari Dokter, Spesialisasi"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border rounded-full text-sm placeholder-gray-400"
          />
        </div>
      </div>

      {/* List Dokter */}
      <div className="px-4">
        {!doctorData || doctorData.length === 0 ? (
          <div className="flex flex-col items-center justify-center text-center mt-8">
            <img src="/images/empty-doctor.png" alt="No Doctor" className="w-[250px] h-[250px] object-contain" />
            <p className="mt-4 font-semibold">Belum ada dokter</p>
            <p className="text-sm text-gray-400">Belum ada data dokter yang dapat ditampilkan...</p>
          </div>
        ) : (
          doctorData.map((doc, index) => (
            <DoctorCard 
              key={index} 
              doctor={doc} 
              onConsult={() => handleKonsultasiClick(doc)}
            />
          ))
        )}
      </div>

      {showFilter && (
        <>
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={() => setShowFilter(false)}
        />
          <DoctorFilterBottomSheet
            filters={filters}
            setFilters={setFilters}
            onClose={() => setShowFilter(false)}
            onApply={() => {
              // logic filter di sini
              setShowFilter(false);
            }}
            onReset={() => {
              setFilters({ gender: '', experience: '', schedule: '' });
            }}
          />
        </>
      )}

      <Service
        isOpen={showService}
        onClose={() => setShowService(false)}
        onSubmit={handleServiceSubmit}
        isOnline={selectedDoctor?.is_online || false}
      />
      <BottomNav />
    </div>
  );
};

export default ListDoctor;
